import {PixKeyType} from '@gatewee/types/recipient-bank-account';
import {
  CreateRecipientBankAccountPayload,
  PixKeyCheckResponse,
} from '@gatewee/types/pix-key-check';
import {sanitizePixKeyForApi} from './pix-key-infer.helper';

/**
 * Maps a successful DICT lookup response into the payload used to create a
 * `RecipientBankAccount`. Falls back to the pixKey/pixKeyType entered by the user
 * when the lookup response omits them (some providers don't echo the key back).
 */
export function mapPixKeyCheckToBankAccountPayload(
  response: PixKeyCheckResponse,
  fallback: {pixKey: string; pixKeyType: PixKeyType},
): CreateRecipientBankAccountPayload {
  const pixKeyType = response.pixKeyType || fallback.pixKeyType;
  return {
    pixKey: sanitizePixKeyForApi(
      response.pixKey || fallback.pixKey,
      pixKeyType,
    ),
    pixKeyType,
    holderName: response.holderName ?? '',
    holderDocument: String(response.holderDocument ?? '').replace(/\D/g, ''),
    compeCode: response.compeCode,
    ispbCode: response.ispbCode,
    agency: response.agency,
    agencyDigit: response.agencyDigit,
    account: response.account,
    accountDigit: response.accountDigit,
    accountType: response.accountType,
    pixKeyE2eId: response.pixKeyE2eId,
  };
}
